<main class="main-section">
  <div>
    <img
      src="assets/img/image-header.jpg"
      alt=""
      class="image-header"
      role="presentation"
    />
  </div>
  <div class="greeting">
    <h1>Hola {{ otpService.loadCachedClient().name }}</h1>
    <h2>{{ localeService.otp.body_1 }}<span class="otp-ref">(Ref: {{ otpService.getAttemptSequence() || localStorage.getItem("attemptSequence") }})</span><br>{{ localeService.otp.body_2 }}</h2>
    <form [formGroup]="otpForm" #otpFormElement>
      <div class="sms-box">
        <input
          type="text"
          class="number"
          data-number="1"
          formControlName="digit1"
          maxlength="1"
          (input)="onInput(otpForm.get('digit1')?.value, 'digit1')"
          (keydown)="checkPossibleBackstep($event, 'digit1')"
        />
        <input
          type="text"
          class="number"
          data-number="2"
          formControlName="digit2"
          maxlength="1"
          (input)="onInput(otpForm.get('digit2')?.value, 'digit2')"
          (keydown)="checkPossibleBackstep($event, 'digit2')"
        />
        <input
          type="text"
          class="number"
          data-number="3"
          formControlName="digit3"
          maxlength="1"
          (input)="onInput(otpForm.get('digit3')?.value, 'digit3')"
          (keydown)="checkPossibleBackstep($event, 'digit3')"
        />
        <input
          type="text"
          class="number"
          data-number="4"
          formControlName="digit4"
          maxlength="1"
          (input)="onInput(otpForm.get('digit4')?.value, 'digit4')"
          (keydown)="checkPossibleBackstep($event, 'digit4')"
        />
        <input
          type="text"
          class="number"
          data-number="5"
          formControlName="digit5"
          maxlength="1"
          (input)="onInput(otpForm.get('digit5')?.value, 'digit5')"
          (keydown)="checkPossibleBackstep($event, 'digit5')"
        />
        <input
          type="text"
          class="number"
          data-number="6"
          formControlName="digit6"
          maxlength="1"
          (input)="onInput(otpForm.get('digit6')?.value, 'digit6')"
          (keydown)="checkPossibleBackstep($event, 'digit6')"
        />
      </div>

      @if(hasError()) {
        <div class="error">
          <p>Código OTP incompleto</p>
        </div>
      }

      @if(!otpService.getIsValidOtp() && otpService.isOtpSubmitted()) {
        <div class="error">
          <p class="otp-generation-link">El número no coincide con el código enviado. <span [class.disabled]="otpService.areLinksDisabled" (click)="otpService.getOtp()">{{ localeService.otp.body_error }}</span></p>
        </div>
      }
  
      @if(!otpService.isOtpSubmitted()) {
        <div>
          <p class="otp-generation-link">Si no recibiste el código, <span [class.disabled]="otpService.areLinksDisabled" (click)="otpService.getOtp()">{{ localeService.otp.body_3 }}</span></p>
        </div>
      }
      
      <div class="btn-group">
        <button
          class="btn-primary"
          (click)="onSubmit()"
          [disabled]="otpForm.invalid || otpService.areLinksDisabled"
        >
          <b>Enviar</b>
        </button>
      </div>
    </form>
  </div>
</main>
